import { useMutation } from '@tanstack/react-query';
import { assignLoaner } from '../services/providerDeviceService';
import providerService from '../services/providerService';

/**
 * Custom hook for the assign loaner mutation.
 * @returns {Object} React Query useMutation result
 */
export const useAssignLoaner = () => {
  const { providerId } = providerService.getProviderDetails();

  return useMutation({
    mutationFn: ({ assetId, patientId }) =>
      assignLoaner(providerId, assetId, patientId),
  });
};
